export interface AttendancePlayer {
  id: string
  player_number?: number | null
  is_suspended?: boolean
  is_proposed_starting?: boolean
}

export const getActivePlayerNumbers = (players: AttendancePlayer[]): number[] =>
  [
    ...new Set(
      players
        .filter((player) => !player.is_suspended)
        .map((player) => player.player_number)
    ),
  ]
    .filter((n): n is number => n !== null && n !== undefined)
    .sort((a, b) => a - b)

export const getJerseyConflicts = (
  players: AttendancePlayer[]
): Record<string, number> =>
  players.reduce<Record<string, number>>((collector, player) => {
    const key = String(player.player_number)
    if (Object.prototype.hasOwnProperty.call(collector, key)) {
      collector[key]++
    } else {
      collector[key] = 0
    }
    return collector
  }, {})

export const hasStartingGoalie = (
  players: AttendancePlayer[],
  affiliates: AttendancePlayer[]
): boolean =>
  players.some((player) => player.is_proposed_starting) ||
  affiliates.some((player) => player.is_proposed_starting)
